import { __awaiter } from "tslib";
import { createSlice } from '../context';
import { createSerializer } from '../serializer';
import { createTimer } from '../timing';
import { marksCtx, nodesCtx, remarkCtx, schemaCtx } from '.';
import { SchemaReady } from './schema';
export const serializerCtx = createSlice(() => '', 'serializer');
export const serializerTimerCtx = createSlice([], 'serializerTimer');
export const SerializerReady = createTimer('SerializerReady');
export const serializer = (pre) => {
    pre.inject(serializerCtx).inject(serializerTimerCtx, [SchemaReady]).record(SerializerReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(serializerTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const remark = ctx.get(remarkCtx);
        const schema = ctx.get(schemaCtx);
        const children = [...nodes, ...marks];
        const spec = Object.fromEntries(children.map((child) => [child.id, child.serializer]));
        ctx.set(serializerCtx, createSerializer(schema, spec, remark));
        ctx.done(SerializerReady);
    });
};
//# sourceMappingURL=serializer.js.map